<template>
  <div>
    <v-layout row justify-space-between align-center>
      <v-flex grow>
        <h3 class="d-inline-block all-caps mr-3">Dosimeter Badge</h3>
        <span>Last upload: {{ profile.last_dosimetry_upload_date | moment("MM/DD/YYYY") }}</span>
        <v-btn v-if="false" disabled>
          <v-icon left>add</v-icon>
          Request New Reading
        </v-btn>
      </v-flex>
      <v-flex>
        <v-dialog v-model="newCertificationDialog" max-width="290">
          <v-btn slot='activator'>
            <v-icon left>add</v-icon>
            New Certification
          </v-btn>
          <v-card>
            <v-card-title class="headline">Add Certification</v-card-title>
            <v-card-text>
              <v-combobox
                 v-model="selectedCertification"
                :items="baseCertifications"
                item-text="name"
                item-value="name"
                label="Certification Type"
              >
              </v-combobox>

                <v-radio-group v-show="otherSelected"
                  v-model="certificationCategory"
                >
                  <v-radio
                    label="Certification"
                    value="Certification"
                  ></v-radio>
                  <v-radio
                    label="Insurance"
                    value="Insurance"
                  ></v-radio>
                </v-radio-group>

              <Uploader accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" @presigned="certification_file_data = $event">
              </Uploader>

              <v-layout row wrap>
                <v-flex>
                  <v-menu
                    ref="certStartDateMenu"
                    v-model="certStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        v-model="certStartDate"
                        label="Certification Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="certStartDate" @input="certStartDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex>
                  <v-menu
                    ref="certExpirtaionDateMenu"
                    v-model="certExpirtaionDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        v-model="certExpirtaionDate"
                        label="Expiration Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="certExpirtaionDate" @input="certExpirtaionDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-text-field
                v-model="certification_notes"
                label="Notes"
              >
              </v-text-field>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="newCertificationDialog = false">Nevermind</v-btn>
              <v-btn color='success' @click.prevent="saveCertification()" :disabled="!presignedPresent" v-show="chosenFilename" :loading="!presignedPresent || apiCallPending">
                Create
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <hr />

    <v-layout justify-space-around wrap>
      <v-layout row>
        <v-flex shrink class="ma-2" >
          <h2 class="all-caps">Certifications</h2>
          <CertificationsTable
            :headers="certificationHeaders"
            :items="employeeCertifications"
          ></CertificationsTable>
        </v-flex>
        <v-flex shrink class=" ma-2" >
          <h2 class="all-caps">Insurance</h2>
          <CertificationsTable
            :headers="certificationHeaders"
            :items="employeeInsurances"
          ></CertificationsTable>
        </v-flex>
      </v-layout>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Info from '@/components/hr/info.vue'
import EmployeeField from '@/components/hr/employee-field.vue'
import EmployeeDateField from '@/components/hr/employee-date-field.vue'
import EmployeeCheckboxField from '@/components/hr/employee-checkbox-field.vue'
import Uploader from '@/components/hr/uploader.vue'
import ImagePreview from '@/components/hr/image-preview.vue'
import CertificationsTable from '@/components/hr/certifications-table.vue'

export default {
  components: {
    Info,
    EmployeeField,
    EmployeeDateField,
    EmployeeCheckboxField,
    Uploader,
    ImagePreview,
    CertificationsTable,
  },
  props: [
    'employee'
  ],
  created() {
    this.$store.dispatch('profiles/getUserID', this.employee.id).then((p) => {
      this.profile = p
    })
  },
  computed: {
    ...mapGetters('employees', [
      'employeeCertifications',
      'employeeInsurances',
    ]),
    otherSelected: function() {
      if (
        this.selectedCertification &&
        !this.baseCertifications.includes(this.selectedCertification)
      ) {
        return true
      }
      return false
    },
    baseCertifications: function() {
      return this.$store.state.employees.baseCertifications.concat("Other (fill in)")
    },
    presignedPresent: function() {
      if (this.certification_file_data && this.certification_file_data.id) {
        return true
      } else {
        return false
      }
    },
    chosenFilename: function() {
      return this.$store.state.uploader.fileName
    },
  },
  methods: {
    saveCertification () {
      this.apiCallPending = true
      this.$store.dispatch('employees/saveCertification',
        {
          id: this.employee.id,
          certification_file_data: this.certification_file_data,
          start_date: this.certStartDate,
          expiration_date: this.certExpirtaionDate,
          certification_type: this.selectedCertification,
          certification_category: this.certificationCategory,
          certification_notes: this.certification_notes,
        }
      ).finally(res => {
        this.$store.commit('uploader/setImage', null)
        this.$store.commit('uploader/setFilename', '')
        this.apiCallPending = false
        this.newCertificationDialog = false
        this.newOtherCertificationDialog = false
        this.certStartDate = new Date().toISOString().substr(0, 10)
        this.certExpirtaionDate = new Date().toISOString().substr(0, 10)
        this.selectedCertification = ''
        this.certificationCategory = ''
        this.certification_notes = ''
        this.certification_file_data = null
      })
    },
  },
  data: function() {
    return {
      profile: {},
      advancedCertifications: [],
      certificationHeaders: [
        {
          text: 'Title',
          align: 'left',
          value: 'certification_type',
          width: '40%',
        },
        {
          text: 'Start Date',
          value: 'start_date',
          align: 'right',
        },
        {
          text: 'Expiration Date',
          value: 'expiration_date',
          align: 'right',
        },
        {
          text: 'Attachment',
          sortable: false,
          align: 'right',
        },
      ],
      apiCallPending: false,
      certStartDateMenu: false,
      certStartDate: new Date().toISOString().substr(0, 10),
      certExpirtaionDateMenu: false,
      certExpirtaionDate: new Date().toISOString().substr(0, 10),
      selectedCertification: '',
      certificationCategory: '',
      newCertificationDialog: false,
      newOtherCertificationDialog: false,
      certification_file_data: null,
      certification_notes: '',
    }
  },
}
</script>
